
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

interface AuthLayoutProps {
  children: React.ReactNode;
}

export const AuthLayout = ({ children }: AuthLayoutProps) => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex flex-col items-center justify-center py-16 px-4 bg-background">
      <div className="w-full max-w-md animate-fadeIn">
        <div className="mb-8">
          <Button
            variant="ghost"
            onClick={() => navigate("/")}
            className="text-muted-foreground hover:text-foreground mb-6"
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            Back to Menu
          </Button>
          
          <div className="flex items-center justify-center mb-8">
            <img 
              src="/lovable-uploads/82002023-ce31-46c5-b6ce-14f9cdbffeaa.png" 
              alt="Convergence Logo" 
              className="mr-3 w-8 h-8" 
            />
            <h1 className="text-4xl font-semibold text-foreground">Convergence</h1>
          </div>
        </div>
        
        {children}
      </div>
    </div>
  );
};
